/**
 * Wavlynq is 18+ across every app, every tier.
 * Used by signup form + (later) profile edit screen.
 */
export const isAdult = (dob: string | Date): boolean => {
  const d = typeof dob === "string" ? new Date(dob) : dob;
  if (isNaN(d.getTime())) return false;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
  return age >= 18;
};

export const MIN_AGE = 18;
